import React, { useContext } from 'react';
import { Stack, } from '@mui/material';
import { aiAssistantContext, AIAssistantDisplayMode } from '../../../../../state/AIAssistantContextProvider';
import { spaces } from '../../../../../assets/styles/themes/tokens';
import AIAssistantUserMessage from './AIAssistantUserMessage';
import AIAssistantMessage from './AIAssistantMessage';
import { useSelector } from 'react-redux';
import { getCurrentConversation } from '../../../../../reducers/aiAssistant.selectors';
import AIAssistantStreamedMessage from './AIAssistantStreamedMessage';
import useScreenSize from '../../../../../utils/useScreenSize';
import { aiAssistantEditorContext } from '../../../../../state/AIAssistantEditorProvider';

const AIAssistantMessages = () => {
  const {
    dialogMessagesContainerRef,
    displayMode
  } = useContext(aiAssistantContext);
  const currentConversation = useSelector(getCurrentConversation);
  const isDialogMode = displayMode === AIAssistantDisplayMode.DIALOG;
  const isPageMode = displayMode === AIAssistantDisplayMode.PAGE;
  const { isTextEditorOpen } = useContext(aiAssistantEditorContext);
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isXsOrSmScreen = isXsScreen || isSmScreen;

  const currentConversationMessages = currentConversation?.data?.messages ?? [];
  const shouldUseCompactPadding = isDialogMode || isXsOrSmScreen || (isPageMode && isTextEditorOpen);

  return (
    <Stack
      sx={{
        padding: shouldUseCompactPadding ? spaces.md : spaces.xxl,
        maxWidth: '1440px',
        margin: '0 auto'
      }}
      ref={dialogMessagesContainerRef} data-testid='ai-assistant-chat-messages'>
      {currentConversationMessages.map((message, index) => message.role === 'user' ? (
        <AIAssistantUserMessage message={message} key={index} />
      ) : (
        <AIAssistantMessage
          message={message}
          isLast={index === currentConversationMessages.length - 1}
          withRegenerateButton={index === currentConversationMessages.length - 1}
          key={index}
        />
      ))}
      <AIAssistantStreamedMessage />
    </Stack>
  );
};

export default AIAssistantMessages;
